import { render, staticRenderFns } from "./custConvertListSpain.vue?vue&type=template&id=5aa88352&scoped=true"
import script from "./custConvertListSpain.vue?vue&type=script&lang=js"
export * from "./custConvertListSpain.vue?vue&type=script&lang=js"
import style0 from "./custConvertListSpain.vue?vue&type=style&index=0&id=5aa88352&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa88352",
  null
  
)

export default component.exports